import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Order } from '@pedix-workspace/utils';
import { AnalyticsService } from '@pedix-workspace/pedixapp-core-services';
import { WhatsappLinkService } from '@pedix-workspace/angular-utils';

import { TranslocoDirective } from '@jsverse/transloco';
import { IconWhatsappComponent } from '@pedix-workspace/angular-ui-icons';

@Component({
    selector: 'pxw-order-details-customer',
    templateUrl: './order-details-customer.component.html',
    styleUrls: ['./order-details-customer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, IconWhatsappComponent]
})
export class OrderDetailsCustomerComponent {
  private readonly whatsappLinkService = inject(WhatsappLinkService);
  private readonly analyticsService = inject(AnalyticsService);

  readonly name = input.required<string | null>();
  readonly phone = input.required<string | null>();
  readonly whatsappButtonEnabled = input(false);

  readonly whatsappLink = computed(() =>
    this.whatsappLinkService.generateLink({
      phone: String(this.phone()),
    }),
  );

  protected readonly whatsappTarget = this.whatsappLinkService.getWhatsappLinkHttpTarget();

  onWhatsappClick() {
    this.analyticsService.logEvent('orders_whatsapp');
  }
}
